import ExploreByCategories from "../../components/UserComponents/exploreByCategories";
import HeroSection from "../../components/UserComponents/heroSection";
import TopExperience from "../../components/UserComponents/topExperience";
import BookWithConfidence from "../../components/UserComponents/bookWithConfidence";
import { usePublicExperiences } from "../../custom-hooks/queries";
import { debounce } from "../../utils/HelperMethod";
import { use, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const [search, setSearch] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");
  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        setDebouncedValue(value);
      }, 500),
    [],
  );

  const handleSearchChange = (value) => {
    setSearch(value); // input ke liye instant
    debouncedSearch(value); // API ke liye delayed
  };
  const nav = useNavigate();

  const { data: topExperiencesData, isLoading: isTopExperiencesLoading } =
    usePublicExperiences({
      page: 1,
      pageSize: 10,
      isTop: true,
      search: debouncedValue,
    });

  const topExperiences =
    topExperiencesData?.data?.data ||
    topExperiencesData?.items ||
    topExperiencesData?.data ||
    [];
  return (
    <>
      <HeroSection
        searchValue={search}
        onSearchChange={handleSearchChange}
        title="Curated Experiences. Clear availability. Easy Booking"
        description="Everything you need to find and book the right experience - without the friction"
        searchPlaceholder="Search experiences or location"
        home={true}
      />
      <TopExperience
        title="Popular nearby experiences"
        showCategories={false}
        showDescription={false}
        // showViewAll={true}
        experiences={topExperiences}
        isLoading={isTopExperiencesLoading}
        onExperienceClick={(id) => nav(`/user/experience/${id}`)}
      />{" "}
      <BookWithConfidence />
      {/* <ExploreByCategories /> */}
    </>
  );
};

export default Home;
